export default "__VITE_ASSET__BAYTpdDa__"